const closeOpener = () => {
  console.warn('Closing openers...')

  if (window && window.opener) {
    window.opener.close()
  }
}

export const closeOpenerIfCrossOrigin = () => {
  if (window && window.opener) {
    try {
      if (window.opener.origin !== window.origin) {
        closeOpener()
      }
    } catch (e) {
      closeOpener()
    }
  }
}
